import { render, staticRenderFns } from "./audit-table.vue?vue&type=template&id=33cd12bd&scoped=true&"
import script from "./audit-table.vue?vue&type=script&lang=js&"
export * from "./audit-table.vue?vue&type=script&lang=js&"
import style0 from "./audit-table.vue?vue&type=style&index=0&id=33cd12bd&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33cd12bd",
  null
  
)

export default component.exports